"use client";

import React from "react";
import { cn } from "utils/utils";

/**
 * A responsive container for chart components that adapts layout for mobile
 */
interface ChartContainerProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  attribution?: React.ReactNode;
  controls?: React.ReactNode;
}

export function ChartContainer({
  children,
  className,
  title,
  attribution,
  controls,
}: ChartContainerProps) {
  return (
    <div className={cn("card w-full shadow-sm", className)}>
      <div className="card-body flex flex-col gap-0 p-3 md:p-4">
        <div
          className={cn(
            "flex items-center gap-2",
            "flex-col md:flex-row md:justify-between"
          )}
        >
          {title && (
            <h3 className="text-base-content/80 w-full text-sm font-medium md:text-base">
              {title}
            </h3>
          )}

          {/* Controls are stacked on mobile, inline on desktop */}
          {controls && (
            <div
              className={cn(
                "flex w-full items-center",
                "flex-col gap-1.5 md:flex-row md:justify-end md:gap-3"
              )}
            >
              {controls}
            </div>
          )}
        </div>

        <div className="mt-2 md:mt-3">{children}</div>

        {attribution && (
          <div className={cn("mt-2 flex", "justify-center md:justify-end")}>
            {attribution}
          </div>
        )}
      </div>
    </div>
  );
}
